const deps = {};

class PrerollController {

  constructor($element, $scope, adService, VG_STATES) {
    deps.$element = $element;
    deps.$scope = $scope;
    deps.adService = adService;
    deps.VG_STATES = VG_STATES;

    this.name = 'vgPreroll';
    this.lockControls = false;
    this.adLoading = false;
    this.adLoaded = false;

    $scope.$watch(
      () => {
        return this.API.isReady;
      },
      (newVal, oldVal) => {
        if (this.API.isReady || newVal !== oldVal) {
          this.onPlayerReady(newVal);
        }
      }
    );

    $scope.$watch(
      () => {
        return this.API.currentState;
      },
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.onUpdateState(newVal);
        }
      }
    );
  }

  initializeContainer() {
    this.videoElement = deps.$element.find('video');
    this.sourceElement = deps.$element.find('source');
    this.videoElement[0].addEventListener('ended', this.onAdEnded.bind(this));
    this.videoElement[0].addEventListener('error', this.onAdSkipped.bind(this));
  }

  onPlayerReady(isReady) {
    if (isReady) {
      this.initializeContainer();
    }
  }

  onAdEnded() {
    deps.$element.addClass('ng-hide');
    this.lockControls = false;
    this.adLoaded = true;
    this.onComplete();
    this.API.play();
  }

  onAdSkipped() {
    deps.$element.addClass('ng-hide');
    this.lockControls = false;
    this.adLoaded = true;
    this.onSkipped();
    this.API.play();
  }

  onUpdateState(newState) {
    if (newState === deps.VG_STATES.PLAY && !this.adLoaded) {
      this.lockControls = true;
      this.API.pause();
      if (!this.adLoading) {
        this.requestAd(this.region, this.category);
        this.adLoading = true;
      }
    }
  }

  requestAd(region, section) {
    return deps.adService.getAd('preroll', section, region)
      .then((data) => {
        this.adData = data;
        if (data.vod) {
          this.loadVideo(data.vod);
        } else {
          // in case the response has no ad src url
          this.onAdSkipped();
        }
      }, () => {
        console.error('[Preroll] Could not load ad. Resuming video.');
        this.onAdSkipped();
      });
  }

  loadVideo(src) {
    const d = new Date();
    const video = this.videoElement[0];
    const source = this.sourceElement[0];
    source.src = src + '?' + d.getTime();
    video.load();
    video.play();
  }
}

PrerollController.$inject = [
  '$element',
  '$scope',
  'adService',
  'VG_STATES'];

export default PrerollController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/preroll/preroll.controller.js
 **/